import React from 'react';

import { useTheme } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { ReportGridGroupRow } from 'src/components';
import { getIsReportGridRow, useCellStyles } from 'src/components';
import { FavoriteStarIcon } from 'src/components/icons/FavoriteStarIcon';
import type { Apollo } from 'src/gql/generated';

type FavoriteRow = Pick<Apollo.Document, 'id' | '__typename'> | ReportGridGroupRow;

export function FavoriteCell({
  row,
  value: favorited,
}: GridCellParams<FavoriteRow, boolean, unknown>): JSX.Element {
  const theme = useTheme();
  const classes = useCellStyles();

  if (!getIsReportGridRow(row)) return <div className={classes.cell} />;

  return (
    <div className={classes.cell}>
      <FavoriteStarIcon fill={favorited ? theme.appColors.accent5 : theme.appColors.rule} />
    </div>
  );
}
